import Vue from 'vue'
import Router from 'vue-router'

import routersMap from '@/routes/map' // 路由映射

Vue.use(Router)

const router = new Router({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes: routersMap,
    scrollBehavior (to, from, savedPosition) { // HTML5 history 模式有效
        if (savedPosition) {
            return savedPosition
        }
        return {x: 0, y: 0}
    }
})

export default router
